var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-overlay', {
    attrs: {
      "show": _vm.loading
    }
  }, [_c('section', [_c('div', {
    staticClass: "d-flex justify-content-between align-items-center mb-1"
  }, [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "outline-secondary"
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.$router.push({
          name: 'penerimaan-barang'
        });
      }
    }
  }, [_c('feather-icon', {
    staticClass: "mr-50",
    attrs: {
      "icon": "ArrowLeftIcon"
    }
  }), _vm._v(" Kembali ")], 1), _vm.pb.selesai == 0 ? _c('b-button', {
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.$router.push({
          name: 'penempatan',
          query: {
            no_inv: _vm.pb.no_invoice
          }
        });
      }
    }
  }, [_c('span', {
    staticClass: "align-middle"
  }, [_vm._v("Tempatkan Barang")]), _c('feather-icon', {
    staticClass: "ml-1",
    attrs: {
      "icon": "ChevronRightIcon"
    }
  })], 1) : _vm._e()], 1), _c('b-card', {
    staticClass: "mb-2"
  }, [_c('b-row', [_c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "d-flex flex-wrap align-items-center justify-content-between"
  }, [_c('div', [_c('small', {
    staticClass: "text-muted d-block"
  }, [_vm._v("No. Invoice")]), _c('h4', {
    staticClass: "mb-0"
  }, [_vm._v(_vm._s(_vm.pb.no_invoice || "-"))])]), _c('b-badge', {
    staticClass: "mt-50",
    attrs: {
      "variant": _vm.pb.selesai == 1 ? 'success' : 'danger'
    }
  }, [_vm._v(" " + _vm._s(_vm.pb.selesai == 1 ? "Selesai" : "Belum ditempatkan") + " ")])], 1)]), _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "3",
      "sm": "6"
    }
  }, [_c('small', {
    staticClass: "text-muted d-block"
  }, [_vm._v("Tanggal Invoice")]), _c('strong', [_vm._v(_vm._s(_vm.humanDate(_vm.pb.tanggal_invoice)))])]), _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "3",
      "sm": "6"
    }
  }, [_c('small', {
    staticClass: "text-muted d-block"
  }, [_vm._v("Tanggal Penerimaan")]), _c('strong', [_vm._v(_vm._s(_vm.humanDate(_vm.pb.tanggal_penerimaan)))])]), _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "3",
      "sm": "6"
    }
  }, [_c('small', {
    staticClass: "text-muted d-block"
  }, [_vm._v("Gudang")]), _c('strong', [_vm._v(" " + _vm._s(_vm.pb.gudang && _vm.pb.gudang.nama_gudang ? _vm.pb.gudang.nama_gudang : "-") + " ")])]), _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "3",
      "sm": "6"
    }
  }, [_c('small', {
    staticClass: "text-muted d-block"
  }, [_vm._v("Keterangan")]), _c('strong', [_vm._v(_vm._s(_vm.pb.keterangan ? _vm.pb.keterangan : "-"))])]), _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "3",
      "sm": "6"
    }
  }, [_c('small', {
    staticClass: "text-muted d-block"
  }, [_vm._v("Total Item")]), _c('strong', [_vm._v(_vm._s(_vm.pb.total_rincian != null ? _vm.pb.total_rincian : _vm.barangs.length))])]), _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "3",
      "sm": "6"
    }
  }, [_c('small', {
    staticClass: "text-muted d-block"
  }, [_vm._v("Total Jumlah")]), _c('strong', [_vm._v(_vm._s(_vm.formatRupiah(_vm.pb.total_jumlah != null ? _vm.pb.total_jumlah : 0)))])])], 1)], 1), _c('b-card', [_c('h5', {
    staticClass: "mb-1"
  }, [_vm._v("Daftar Barang Yang Diterima")]), _vm.barangs.length > 0 ? _c('b-table', {
    attrs: {
      "striped": "",
      "hover": "",
      "responsive": "",
      "items": _vm.barangs,
      "fields": _vm.barangFields
    },
    scopedSlots: _vm._u([{
      key: "cell(no)",
      fn: function fn(row) {
        return [_vm._v(" " + _vm._s(row.index + 1) + " ")];
      }
    }, {
      key: "cell(barang)",
      fn: function fn(_ref) {
        var item = _ref.item;
        return [_vm._v(" " + _vm._s(item.barang ? item.barang.nama : "-") + " ")];
      }
    }, {
      key: "cell(jumlah)",
      fn: function fn(_ref2) {
        var item = _ref2.item;
        return [_vm._v(" " + _vm._s(_vm.formatRupiah(item.jumlah)) + " "), item.barang && item.barang.satuan ? _c('span', {
          staticClass: "text-muted"
        }, [_vm._v(" " + _vm._s(item.barang.satuan.satuan) + " ")]) : _vm._e()];
      }
    }, {
      key: "cell(no_container)",
      fn: function fn(_ref3) {
        var item = _ref3.item;
        return [_vm._v(" " + _vm._s(item.no_container || "-") + " ")];
      }
    }, {
      key: "cell(no_seal)",
      fn: function fn(_ref4) {
        var item = _ref4.item;
        return [_vm._v(" " + _vm._s(item.no_seal || "-") + " ")];
      }
    }], null, false, 3210889316)
  }) : _c('p', {
    staticClass: "text-muted mb-0 text-center py-2"
  }, [_vm._v(" Belum ada rincian barang. ")])], 1)], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }